import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";

import MaterialTable from "material-table";
import AskAlert from "../common/AskAlert";
import {
  SERVER_PATH,
  AXIOS_CONFIG,
  ROLE_ADMIN,
} from "../common/redux/constantes";

class ListMembers extends Component {
  static propTypes = {
    member: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    members: [],
    openDeleteAlert: false,
    deleteMemberID: -1,
  };

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }

  deleteMember = () => {
    if (this.state.deleteMemberID !== -1) {
      this.props.actions.deleteMember(this.tableRef, this.state.deleteMemberID);
      this.setState({ openDeleteAlert: false });
    }
  };

  cancelDelete = () => {
    this.setState({ openDeleteAlert: false });
  };

  askDeleteMember = (memberID) => {
    this.setState({ openDeleteAlert: true, deleteMemberID: memberID });
  };

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };

  render() {
    let actionButtons = [
      {
        icon: "delete",
        tooltip: "Delete",
        onClick: (event, rowData) => this.askDeleteMember(rowData.member),
      },
      {
        icon: "edit",
        tooltip: "Edit",
        onClick: (event, rowData) => this.props.editMember(rowData),
      },
      {
        icon: "refresh",
        tooltip: "Refresh Data",
        isFreeAction: true,
        onClick: () =>
          this.tableRef.current && this.tableRef.current.onQueryChange(),
      },
    ];
    //Verificamos permisos
    if (Number(localStorage.getItem("role")) !== ROLE_ADMIN) {
      actionButtons.splice(0, 2);
    }
    return (
      <div>
        <MaterialTable
          tableRef={this.tableRef}
          onRowClick={(evt, selectedRow) => this.setState({ selectedRow })}
          options={{
            actionsColumnIndex: 7,
            paging: false,
            search: false,
            maxBodyHeight: "600px",
            headerStyle: {
              backgroundColor: "#fffff",
              color: "black",
              fontSize: "1.05em",
            },
            rowStyle: (rowData) => {
              return {
                backgroundColor:
                  this.state.selectedRow &&
                  this.state.selectedRow.tableData.id === rowData.tableData.id
                    ? "#EEE"
                    : rowData.tableData.id % 2
                    ? "#fff"
                    : "#f9f9fa",
              };
            },
          }}
          title="Members"
          columns={[
            {
              title: "First Name",
              field: "first_name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Last Name",
              field: "last_name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Position",
              field: "position",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Status",
              field: "member_status",
              lookup: { 1: "Active", 2: "Inactive" },
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = SERVER_PATH + "/members/getAll";
              fetch(url, AXIOS_CONFIG())
                .then((response) => response.json())
                .then((result) => {
                  resolve({
                    data: result.members,
                    page: 0,
                    totalCount: result.members.length,
                  });
                })
                .catch((err) => {
                  resolve({ data: [], page: 0, totalCount: 0 });
                });
            })
          }
          actions={actionButtons}
        />
        <AskAlert
          openAlert={this.state.openDeleteAlert}
          handleCloseCancel={this.cancelDelete}
          handleCloseOk={this.deleteMember}
          dialogTitle="Delete Member"
          dialogContent="Are you sure to delete this member?"
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    member: state.member,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListMembers);



// WEBPACK FOOTER //
// ./src/features/member/ListMembers.js